import apiSlice from '..';

export const vehicleDoNotRunApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    setDoNotRun: builder.mutation<void, { vehicleId: number; doNotRun: boolean }>({
      query: ({ vehicleId, doNotRun }) => ({
        method: 'POST',
        url: `admin/vehicles/${vehicleId}/do-not-run`,
        body: { do_not_run: doNotRun }
      }),
      invalidatesTags: ['DoNotRun']
    }),
    updateDoNotRunNote: builder.mutation<void, { vehicleId: number; note: string }>({
      query: ({ vehicleId, note }) => ({
        method: 'POST',
        url: `admin/vehicles/${vehicleId}/do-not-run-note`,
        body: { note }
      }),
      invalidatesTags: ['DoNotRun']
    })
  }),
  overrideExisting: true
});

export const { useSetDoNotRunMutation, useUpdateDoNotRunNoteMutation } = vehicleDoNotRunApiSlice;
